{
    "startLifeCount": 3,
    "startRoomKey": "enter",
    "endRoomKey": "exit",
    "playerTeamIndex": 0,
    "opponentTeamIndex": 1,
    "combat": {
        "playerRespawnInvulnerabilityTime": 2000
    }
}
